var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9F0004;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tron"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.8,127.7c-10.7-9.9-25.5-25-37.6-35.7l-0.7-0.5c-1.2-1-2.5-1.7-4-2.2l0,0c-29.1-5.4-164.4-30.7-167-30.4 c-0.7,0.1-1.4,0.4-2.1,0.8l-0.7,0.5c-0.8,0.8-1.5,1.9-1.9,3l-0.2,0.5v2.5v0.4C59,109,119.1,248,131,280.6c0.7,2.2,2.1,6.4,4.6,6.6 h0.6c1.4,0,7.1-7.6,7.1-7.6S246.6,154.3,257.1,141c1.4-1.6,2.5-3.4,3.6-5.3C261.2,132.7,260.1,129.7,257.8,127.7z M169.8,142.3 l44.1-36.6l25.9,23.8L169.8,142.3z M152.7,139.9L76.8,77.7l122.8,22.7L152.7,139.9z M159.5,156.2l77.7-12.5l-88.8,107L159.5,156.2z  M66.5,83.9l79.9,67.8l-11.6,99.1L66.5,83.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrx);
export default __webpack_public_path__ + "static/media/TRX.88783f1d48124581d70e92175ed76696.svg";
export { ForwardRef as ReactComponent };